export default __webpack_public_path__ + "static/media/ic_poland.42ca0e14.svg";